import { useState } from 'react';
import { MenuSelect } from '../enum/number-enum';
import NavigationBar from './navigation-bar';
import TenantList from './tenant-list';
import TenantRegister from './tenant-register';
import User from './user';

const Home = () => {
  const [menuSelect, setMenuSelect] = useState<MenuSelect>(MenuSelect.Register);

  return (
    <div className="flex ">
      <span className="w-2/12" />
      <div className="w-8/12">
        <div className="my-2 flex justify-center text-2xl">テナント管理</div>
        <div className="flex">
          <span className="flex-grow" />
          <User />
        </div>
        <div className="flex h-[50rem] rounded border bg-white shadow-xl">
          <div className="h-full basis-36 border-r ">
            <NavigationBar setMenuSelect={setMenuSelect} />
          </div>
          <div className="flex-1 px-10 pt-4">
            {menuSelect === MenuSelect.Register && <TenantRegister />}
            {menuSelect === MenuSelect.List && <TenantList />}
          </div>
        </div>
      </div>
      <span className="w-2/12" />
    </div>
  );
};

export default Home;
